module.exports = __webpack_public_path__ + "media/images/official/special_migration-6060f348e4f98c0ad23c20bbf4cdd54a.jpg";